import axios from 'axios';
import { Loading } from 'element-ui';
import ErrorHandle from './errorHandle';
import router from '@/router'
import { AxiosCanceler } from './axiosCanceler';

function isFileStream(data) {
  return !!(data instanceof Blob || data instanceof ArrayBuffer);
}

let baseURL = "https://beijing-gateway-bside.app-dev.bjev.com.cn/gateway-console/v1/"; //原系统
let bj_baseURL = "https://beijing-gateway-bside.app-dev.bjev.com.cn"; //专区
if (process.env.NODE_ENV === 'production') {
    // 生产
    baseURL = "https://beijing-gateway-bside.app-prod.bjev.com.cn/gateway-console/v1/";
    bj_baseURL = "https://beijing-gateway-bside.app-prod.bjev.com.cn";
}
if (process.env.NODE_ENV === 'pre') {
    // 预生产
    baseURL = "https://console-api.inner-app-pre.bjev.com.cn/gateway-console/v1/";
    bj_baseURL = "https://beijing-gateway-bside.app-pre.bjev.com.cn";
}

const axiosCanceler = new AxiosCanceler();

// create an axios instance
const service = axios.create({
  baseURL: baseURL,
  timeout: 5000
});

// 访问专区域名环境
const service_beijing = axios.create({
  baseURL: bj_baseURL,
  timeout: 5000
});


// request interceptor
const requestSuccess = function(response) {
  const token = localStorage.token;
  response.headers = Object.assign({
    token,
    Authorization: 'Bearer ' + token,
    userId: localStorage.getItem('uid'),
    'Content-Type': 'application/json;charset=UTF-8',
  }, response.headers);
  return response;
};
const requestError = function(error) {
  return Promise.reject(error);
};

// request interceptor
const responseSuccess = function(response) {
  if (response.data.errCode == 2) {
      router.push({
        path: "/login",
        querry: { redirect: router.currentRoute.fullPath }//从哪个页面跳转
      })
  }
  if (!isFileStream(response.data) && response.data.code !== 200 && response.data.code !== 0) {
    ErrorHandle(response.data);
    return Promise.reject(response.data);
  }
  return Promise.resolve(response.data);
};
const responseError = function(error) {
  if (error.response && error.response.status === 401) {
    ErrorHandle({ code: 401, msg: '401' });
  }
  const data = error && error.response && error.response.data ? data : {}
  return Promise.reject(data);
};

service.interceptors.request.use(requestSuccess, requestError);
service.interceptors.response.use(responseSuccess, responseError);

service_beijing.interceptors.request.use(requestSuccess, requestError);
service_beijing.interceptors.response.use(responseSuccess, responseError);

export function request(config = {}) {
  let loading = null;
  const { hasLoading = false, needCancel = true, transformResult = true } = config;
  // 是否需要展示全局Loading框
  if (hasLoading) {
    loading = Loading.service({
      fullscreen: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, .3)'
    });
  }
  // 是否需要将该请求记录到canceler
  if (needCancel) {
    axiosCanceler.addPending(config);
  }
  return service_beijing(config)
    .then((res) => {
      // 是否对返回数据处理，即去掉 axios 包装的一层 data
      // 需要读取response数据中 headers 等数据时设置该字段为 false
      // 默认为 true
      if (transformResult) return res.data;
      return res;
    }).catch((err) => {
      console.log('err===>',err)
      return Promise.reject(err);
    }).finally(() => {
      hasLoading && loading.close();
    });
}


/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get({ url, params = {}, hasLoading = false, headers = {}}) {
  let loading = null;
  if (hasLoading) {
    loading = Loading.service({
      fullscreen: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, .3)'
    });
  }
  return service({
    method: 'get',
    url,
    params,
    headers
  })
    .then(res => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    })
    .finally(() => {
      hasLoading && loading.close();
    });
}
export function getBeijing({ url,  transformResult = true, needCancel = true, method = 'get', params = {}, data = {}, hasLoading = false, headers = {}}) {
  const config = {
    method,
    url,
    params,
    data,
    headers,
    hasLoading,
    needCancel,
    transformResult
  };
  return request(config);
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post({ url, method = 'post', params = {}, data = {}, hasLoading = false, headers = {}}) {
  let loading = null;
  if (hasLoading) {
    loading = Loading.service({
      fullscreen: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, .3)'
    });
  }
  return service({
    method,
    url,
    params,
    data,
    headers
  })
    .then(res => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    })
    .finally(() => {
      hasLoading && loading.close();
    });
}

export function postBeijing({ url,  transformResult = true, needCancel = true, method = 'post', params = {}, data = {}, hasLoading = false, headers = {}}) {
  const config = {
    method,
    url,
    params,
    data,
    headers,
    hasLoading,
    needCancel,
    transformResult
  };
  return request(config);
}

/**
 * 上传文件
 * @param {*} param0
 * @returns
 */

export function uploadFile({ url, data, hasLoading = true }) {
  let loading = null;
  if (hasLoading) {
    loading = Loading.service({
      fullscreen: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, .3)'
    });
  }
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    timeout: 200 * 1000
  };
  return service({
    ...config,
    method: 'post',
    url,
    data
  }).then((res) => {
    return res;
  }).catch((err) => {
    return Promise.reject(err);
  }).finally(() => {
    hasLoading && loading.close();
  });
}

/**
 * 下载文件
 * @param {*} param0
 * @returns
 */
export function downloadFile({ url, method = 'get', params = {}, hasLoading = true, fileName = '' }) {
  let loading = null;
  if (hasLoading) {
    loading = Loading.service({
      fullscreen: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, .3)'
    });
  }
  return service({
    method,
    responseType: 'blob',
    url,
    params,
    timeout: 200 * 1000
  }).then((res) => {
    fileName = fileName || res.headers['content-disposition'].split(';')[1].split('=')[1].trim();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(res.data);
    a.download = decodeURIComponent(fileName);
    a.click();
  }).catch((e) => {
    return Promise.reject(e);
  }).finally((e) => {
    hasLoading && loading.close();
  });
}

export function aliOSS({ method = 'get', url, data = null, headers = {}}) {
  return axios.request({
    method,
    url,
    withCredentials: false,
    headers,
    data
  });
}
